import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faAngleLeft, faInfoCircle, faImage, 
    faMapMarkerAlt, faHistory, faBoxes, faClipboardList, faSearchPlus, faTools 
} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import FotosDescritivasDropzone from "../../../components/administracao/FotosDescritivasDropzone";
import FotosHistoricasDropzone from "../../../components/administracao/FotosHistoricasDropzone";
import LocalizacaoSelector from "../../../components/administracao/LocalizacaoSelector";
import useFetch from "../../../hooks/useFetch";
import Swal from "sweetalert2";

export default function Item() {
  const navigate = useNavigate();
  const { get, post, put } = useFetch();
  const [errors, setErrors] = useState({});

  /* objeto recebido do state={} do <Link> da página anterior
   ** https://v5.reactrouter.com/web/api/location  https://v5.reactrouter.com/web/api/Hooks/uselocation */
  let location = useLocation();

  // https://v5.reactrouter.com/web/example/url-params
  let { id } = useParams();

  // https://stackoverflow.com/questions/37949981/call-child-method-from-parent
  const FotosDescritivasDropzoneRef = useRef();

  const defaultState = {
    acao: "Visualizar",
    item: {
      id_item: "",
      nome_item: "",
      apresentacao: "",
      material: "",
      altura: "",
      largura: "",
      comprimento: "",
      diametro: "",
      profundidade: "",
      peso: "",
      circunferencia: "",
      forma_aquis: "",
      dt_entrada: "",
      dt_saida: "",
      marcas: "",
      procedencia: "",
      origem: "",
      fabricante: "",
      conservacao: "",
      restauracao: "",
      n_patrimonial: "",
      pesquisa: "",
      solicitacao: "",
      bibliografia: "",
      historico: "",
      observacao: "",
      ano_fabricacao: "",
      decada_fabricacao: "",
      Localizacao: {},
      id_localizacao: "",
      exposicao: "",
      status_item: "",
      inventariado_por: "",
    },
    palavrasChave: {
      palavra_chave1: "",
      palavra_chave2: "",
      palavra_chave3: "",
    },
    localizacao: { id_localizacao: "", sala: "", estante: "", prateleira: "" },
    opcoesCategoria: [],
    categoriasSelecionadas: [],
    carregarFotos: false,
    fotosHistoricas: {
      salvas: [
        /** base64, id_item, sec_fotodescritiva, fotodescritiva */
      ],
      adicionadas: [],
    },
    fotosDescritivas: {
      salvas: [],
      adicionadas: [],
    },
  };

  const hasProperties = (obj) => Object.keys(obj).length > 0;

  const removeProperty = (obj, property) => {
    const { [property]: _, ...rest } = obj;
    return rest;
  };

  useEffect(() => {
    const fetchData = async () => {
      let item = defaultState.item;
      let localizacao = defaultState.localizacao;
      let palavras = defaultState.palavrasChave;
      let categoriasSelecionadas = defaultState.categoriasSelecionadas;
      let fotosDescritivas = defaultState.fotosDescritivas;
      let fotosHistoricas = defaultState.fotosHistoricas;

      if (id === "criar") {
        setState({ ...state, acao: "Criar" });
      } else {
        item = await buscarItem(id);
        if (!item.Localizacao) {
          localizacao = defaultState.localizacao;
        } else {
          localizacao = item.Localizacao;
          delete item.Localizacao;
        }
        if (hasProperties(item.CategoriaFuncionals)) {
          categoriasSelecionadas = [];
          categoriasSelecionadas = item.CategoriaFuncionals.map((element) => ({
            value: element.id_categoria,
            label: element.nome_cat,
          }));
          item = removeProperty(item, "CategoriaFuncionals");
        }
        item.PalavraChaves.sort((a, b) => a.sec_palavra - b.sec_palavra);
        if (hasProperties(item.PalavraChaves)) {
          for (let i = 0; i < item.PalavraChaves.length; i++) {
            palavras[`palavra_chave${i + 1}`] = item.PalavraChaves[i].palavra;
          }
          item = removeProperty(item, "PalavraChaves");
        }
        if (hasProperties(item.FotoHistoricas)) {
          fotosHistoricas.salvas = item.FotoHistoricas;
          item = removeProperty(item, "FotoHistoricas");
        }
        if (hasProperties(item.FotoDescritivas)) {
          fotosDescritivas.salvas = item.FotoDescritivas;
          item = removeProperty(item, "FotoDescritivas");
        }
      }
      let categoriasRecebidas = await buscarCategorias({});
      let opcoesCategoria = categoriasRecebidas.map((element) => ({
        value: element.id_categoria,
        label: element.nome_cat,
      }));

      setState({
        ...state,
        item: item,
        localizacao: localizacao,
        opcoesCategoria: opcoesCategoria,
        categoriasSelecionadas: categoriasSelecionadas,
        palavrasChave: palavras,
        fotosDescritivas: fotosDescritivas,
        fotosHistoricas: fotosHistoricas,
        carregarFotos: true,
      });
    };
    fetchData();
  }, [id]);

  /* https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
   ** define o state inicial do componente, o useState retorna um array com 2 elementos,
   ** objeto state e função setState pra atualizar o objeto state */
  const [state, setState] = useState(
    () => {
      // se a página anterior passou um state, retorna ele
      if (location.state) {
        if (location.state.acao) {
          defaultState.acao = location.state.acao;
        }
      }
      // senão, retorna um objeto vazio
      return defaultState;
    },
    () => {
      // função que é executada quando o state é atualizado
      FotosDescritivasDropzoneRef.current.reloadImages(
        state.fotosDescritivas.salvas
      );
    }
  );

  /* https://reactjs.org/docs/hooks-reference.html#functional-updates
   ** handleChange: quando um campo do formulário é alterado, atualiza o objeto state */
  function changeItem(event) {
    let name = event.target.name; // name do campo que disparou o evento
    let value = event.target.value; // value do campo

    // se um campo number receber string, não precisa fazer nada
    if (event.target.type === "number" && isNaN(value)) {
      return;
    }

    // ex: se o campo com name Nome for alterado, atualiza o objeto state com o novo valor do campo Nome
    // { Nome: "novo valor do campo Nome" }
    setState((prevState) => ({
      ...prevState,
      item: {
        ...prevState.item,
        [name]: value,
      },
    }));
  }

  function changePalavraChave(event) {
    let name = event.target.name; // name do campo que disparou o evento
    let value = event.target.value; // value do campo

    // ex: se o campo com name Nome for alterado, atualiza o objeto state com o novo valor do campo Nome
    // { Nome: "novo valor do campo Nome" }
    setState((prevState) => ({
      ...prevState,
      palavrasChave: {
        ...prevState.palavrasChave,
        [name]: value,
      },
    }));
  }

  function changeCategoria(data) {
    state.categoriasSelecionadas = data;
    setState({ ...state, categoriasSelecionadas: data });
  }

  async function buscarItem(id) {
    try {
      let response = await get("/item/" + id);
      if (response.ok) {
        let dados = response.result.data;
        if (!dados || Object.keys(dados).length === 0) return defaultState.item;
        return dados;
      } else {
        return defaultState.item;
      }
    } catch (error) {
      console.error("Erro no buscarItem():", error);
      return defaultState.item;
    }
  }

  async function salvarFotosDescritivas(id_item) {
    try {
      if (state.fotosDescritivas.adicionadas.length === 0) return null;

      for (let i = 0; i < state.fotosDescritivas.adicionadas.length; i++) {
        let foto = state.fotosDescritivas.adicionadas[i];
        // criar formData com as imagens e descrições
        let formData = new FormData();
        formData.append("foto", new File([foto.value], "image.png"));

        // post fotos adicionadas
        let response = await post(
          `/fotodescritiva/${id_item}`,
          formData,
          null,
          "multipart/form-data"
        );
        if (!response.ok) {
          console.error("Erro no salvarFotosDescritivas():", response);
          return null;
        }
      }
    } catch (error) {
      console.error("Erro no salvarFotosDescritivas():", error);
      return null;
    }
  }

  async function salvarFotosHistoricas(id_item) {
    try {
      // fotos com descrição editada
      let fotosHistoricaEditadas = state.fotosHistoricas.salvas.filter(
        (foto) => {
          return foto.editada === true;
        }
      );
      // put atualizar descrições
      for (let i = 0; i < fotosHistoricaEditadas.length; i++) {
        let foto = fotosHistoricaEditadas[i];
        let body = { descricao: foto.descricao };
        let response = await put(
          `/fotohistorica/${id_item}/${foto.sec_fotohistorica}`,
          body
        );
        if (!response.ok) {
          console.error("Erro no salvarFotosHistoricas():", response);
          return null;
        }
      }

      // fotos adicionadas
      for (let i = 0; i < state.fotosHistoricas.adicionadas.length; i++) {
        let foto = state.fotosHistoricas.adicionadas[i];
        // criar formData com as imagens e descrições
        let formData = new FormData();
        formData.append("foto", new File([foto.value], "image.png"));
        formData.append("descricao", foto.descricao);
        // post fotos adicionadas
        let response = await post(
          `/fotohistorica/${id_item}`,
          formData,
          null,
          "multipart/form-data"
        );
        if (!response.ok) {
          console.error("Erro no salvarFotosHistoricas():", response);
          return null;
        }
      }
    } catch (error) {
      console.error("Erro no salvarFotosHistoricas():", error);
      return null;
    }
  }

  async function salvarItem() {
    let method = state.acao === "Criar" ? post : put;
    try {
      let categoriasRecebidas = [];
      state.categoriasSelecionadas.forEach((element) => {
        categoriasRecebidas.push(element.value);
      });
      let body = {
        ...state.item,
        ...state.localizacao,
        ...state.palavrasChave,
        categoriasRecebidas: categoriasRecebidas,
      };
      let response = await method(`/item/${state.item.id_item}`, body);
      if (response.ok) {
        if (state.fotosDescritivas.adicionadas.length > 0) {
          await salvarFotosDescritivas(response.result.data);
        }
        // check if there is a fotoHistoricas.salvas that has editada === true
        if (
          state.fotosHistoricas.salvas.length > 0 ||
          state.fotosHistoricas.adicionadas.length > 0
        ) {
          await salvarFotosHistoricas(response.result.data);
        }
        Swal.fire({
          title: "Item salvo com sucesso!",
          icon: "success",
        });
        navigate("/admin/itens");
      } else if (response.status === 600) {
        Swal.fire({
          title: "Não foi possível salvar o item",
          text: "A localização colocada não existe.",
          icon: "error",
        });
      } else {
        Swal.fire({
          title: "Não foi possível salvar o item",
          text: "Erro ao salvar item",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Erro no salvarItem():", error);
    }
  }

  async function buscarCategorias(filtros) {
    // filtros = { nome: "nome_cat", descricao: "descricao" }
    let query = "?";
    if (filtros && Object.keys(filtros).length > 0) {
      for (const key in filtros) {
        if (filtros[key] !== "") {
          query = query.concat(key, "=", filtros[key], "&");
        }
      }
    }
    // no fim fica: nome_cat=nome_cat&descricao=descricao&
    try {
      let response = await get("/categoria" + query);
      if (response.status === 200) {
        let dados = response.result.data;
        return dados;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Erro no buscarCategorias():", error);
    }
  }

  function fotosDescritivasAdicionadas(imagens) {
    setState((prevState) => ({
      ...prevState,
      fotosDescritivas: {
        ...imagens,
      },
    }));
  }

  function fotosHistoricasAdicionadas(imagens) {
    console.log(imagens);
    setState((prevState) => ({
      ...prevState,
      fotosHistoricas: {
        ...imagens,
      },
    }));
  }

  // Estilos para os componentes Select (Categorias)
  const selectStyles = {
      control: (provided, state) => ({
          ...provided,
          backgroundColor: '#f8fafc',
          borderColor: state.isFocused ? '#587b7f' : '#e2e8f0',
          borderRadius: '10px',
          minHeight: '44px',
          boxShadow: state.isFocused ? '0 0 0 3px rgba(88, 123, 127, 0.1)' : 'none',
          '&:hover': { borderColor: '#587b7f' }
      }),
      option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected ? '#587b7f' : state.isFocused ? '#f1f5f9' : '#fff',
          color: state.isSelected ? '#fff' : '#334155',
      }),
      multiValue: (provided) => ({
          ...provided,
          backgroundColor: 'rgba(88, 123, 127, 0.1)',
          borderRadius: '6px',
      }),
      multiValueLabel: (provided) => ({
          ...provided,
          color: '#587b7f',
          fontWeight: '600'
      })
  };
  
  return (
        <div className="admin-page-container">
            <div className="mb-4">
                <Link to="/admin/itens" className="btn-back-modern">
                    <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Voltar à listagem
                </Link>
            </div>

            <Card className="filter-card-admin">
                <Card.Body className="p-4 p-md-5">
                    <div className="section-title-modern mb-5">
                        <div className="title-accent"></div>
                        <div>
                            <h2 className="admin-title">{state.acao} Item do Acervo</h2>
                            <p className="admin-subtitle small mb-0">Gestão técnica detalhada de artefatos</p>
                        </div>
                    </div>

                    <Form>
                        {/* GRUPO 1: IDENTIFICAÇÃO */}
                        <div className="form-section-header mb-4">
                            <FontAwesomeIcon icon={faInfoCircle} className="me-2 text-teal" />
                            <span>Identificação e Categorias</span>
                        </div>
                        <div className="row g-4 mb-5">
                            <Form.Group className="col-md-8">
                                <Form.Label className="label-admin">* Nome do Item</Form.Label>
                                <Form.Control className="input-moderno" name="nome_item" value={state.item.nome_item} onChange={changeItem} disabled={state.acao === "Visualizar"} />
                            </Form.Group>
                            <Form.Group className="col-md-4">
                                <Form.Label className="label-admin">Nº Patrimonial FMRP</Form.Label>
                                <Form.Control className="input-moderno" name="n_patrimonial" value={state.item.n_patrimonial} onChange={changeItem} disabled={state.acao === "Visualizar"} />
                            </Form.Group>
                            <Form.Group className="col-md-4">
                                <Form.Label className="label-admin">Palavra-Chave 1</Form.Label>
                                <Form.Control className="input-moderno" name="palavra_chave1" value={state.palavrasChave.palavra_chave1} onChange={changePalavraChave} disabled={state.acao === "Visualizar"} />
                            </Form.Group>
                            <Form.Group className="col-md-4">
                                <Form.Label className="label-admin">Palavra-Chave 2</Form.Label>
                                <Form.Control className="input-moderno" name="palavra_chave2" value={state.palavrasChave.palavra_chave2} onChange={changePalavraChave} disabled={state.acao === "Visualizar"} />
                            </Form.Group>
                            <Form.Group className="col-md-4">
                                <Form.Label className="label-admin">Palavra-Chave 3</Form.Label>
                                <Form.Control className="input-moderno" name="palavra_chave3" value={state.palavrasChave.palavra_chave3} onChange={changePalavraChave} disabled={state.acao === "Visualizar"} />
                            </Form.Group>
                            <Form.Group className="col-12">
                                <Form.Label className="label-admin">Categoria</Form.Label>
                                <Select isMulti options={state.opcoesCategoria} value={state.categoriasSelecionadas} onChange={changeCategoria} styles={selectStyles} isDisabled={state.acao === "Visualizar"} placeholder="Selecione categoria(s)..." />
                            </Form.Group>
                        </div>

                        {/* GRUPO 2: LOCALIZAÇÃO E FOTOS */}
                        <div className="row g-5 mb-5">
                            <div className="col-lg-7">
                                <div className="form-section-header mb-4">
                                    <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 text-teal" />
                                    <span>Localização no Acervo</span>
                                </div>
                                <LocalizacaoSelector
                                    niveis={["sala", "estante", "prateleira"]}
                                    valores={state.localizacao}
                                    onChange={(v) => setState((prevState) => ({ ...prevState, localizacao: v }))}
                                    disabled={state.acao === "Visualizar"}
                                />
                            </div>
                            <div className="col-lg-5">
                                <div className="form-section-header mb-4">
                                    <FontAwesomeIcon icon={faImage} className="me-2 text-teal" />
                                    <span>Fotos Descritivas</span>
                                </div>
                                {state.carregarFotos && (
                                    <FotosDescritivasDropzone fotosDescritivasAdicionadas={fotosDescritivasAdicionadas} fotosDescritivasSalvas={state.fotosDescritivas.salvas} acao={state.acao} ref={FotosDescritivasDropzoneRef} />
                                )}
                            </div>
                        </div>

                        {/* GRUPO 3: FÍSICO */}
                        <div className="form-section-header mb-4">
                            <FontAwesomeIcon icon={faBoxes} className="me-2 text-teal" />
                            <span>Dimensões e Material</span>
                        </div>
                        <div className="row g-3 mb-5">
                            <Form.Group className="col-md-12">
                                <Form.Label className="label-admin">Material</Form.Label>
                                <Form.Control as="textarea" rows={2} className="input-moderno" name="material" value={state.item.material} onChange={changeItem} disabled={state.acao === "Visualizar"} />
                            </Form.Group>
                            <div className="col-12 row g-3 m-0 p-0">
                                <div className="col-md-2"><Form.Label className="label-admin">Alt (cm)</Form.Label><Form.Control className="input-moderno" name="altura" value={state.item.altura} onChange={changeItem} disabled={state.acao === "Visualizar"} /></div>
                                <div className="col-md-2"><Form.Label className="label-admin">Larg (cm)</Form.Label><Form.Control className="input-moderno" name="largura" value={state.item.largura} onChange={changeItem} disabled={state.acao === "Visualizar"} /></div>
                                <div className="col-md-2"><Form.Label className="label-admin">Comp (cm)</Form.Label><Form.Control className="input-moderno" name="comprimento" value={state.item.comprimento} onChange={changeItem} disabled={state.acao === "Visualizar"} /></div>
                                <div className="col-md-2"><Form.Label className="label-admin">Diâm (cm)</Form.Label><Form.Control className="input-moderno" name="diametro" value={state.item.diametro} onChange={changeItem} disabled={state.acao === "Visualizar"} /></div>
                                <div className="col-md-2"><Form.Label className="label-admin">Circunf (cm)</Form.Label><Form.Control className="input-moderno" name="circunferencia" value={state.item.circunferencia} onChange={changeItem} disabled={state.acao === "Visualizar"} /></div>
                                <div className="col-md-2"><Form.Label className="label-admin">Prof (cm)</Form.Label><Form.Control className="input-moderno" name="profundidade" value={state.item.profundidade} onChange={changeItem} disabled={state.acao === "Visualizar"} /></div>
                                <div className="col-md-4"><Form.Label className="label-admin">Peso</Form.Label><Form.Control className="input-moderno" name="peso" value={state.item.peso} onChange={changeItem} disabled={state.acao === "Visualizar"} /></div>
                            </div>
                        </div>

                        {/* GRUPO 4: HISTÓRICO E AQUISIÇÃO */}
                        <div className="form-section-header mb-4">
                            <FontAwesomeIcon icon={faClipboardList} className="me-2 text-teal" />
                            <span>Histórico de Origem e Aquisição</span>
                        </div>
                        <div className="row g-4 mb-5">
                            <Form.Group className="col-md-4"><Form.Label className="label-admin">Forma de Aquisição</Form.Label><Form.Control as="textarea" rows={2} className="input-moderno" name="forma_aquis" value={state.item.forma_aquis} onChange={changeItem} disabled={state.acao === "Visualizar"} /></Form.Group>
                            <Form.Group className="col-md-4"><Form.Label className="label-admin">Procedência</Form.Label><Form.Control as="textarea" rows={2} className="input-moderno" name="procedencia" value={state.item.procedencia} onChange={changeItem} disabled={state.acao === "Visualizar"} /></Form.Group>
                            <Form.Group className="col-md-4"><Form.Label className="label-admin">Origem</Form.Label><Form.Control as="textarea" rows={2} className="input-moderno" name="origem" value={state.item.origem} onChange={changeItem} disabled={state.acao === "Visualizar"} /></Form.Group>
                            <Form.Group className="col-md-4"><Form.Label className="label-admin">Fabricante</Form.Label><Form.Control as="textarea" rows={2} className="input-moderno" name="fabricante" value={state.item.fabricante} onChange={changeItem} disabled={state.acao === "Visualizar"} /></Form.Group>
                            <div className="col-md-2"><Form.Label className="label-admin">Data Entrada</Form.Label><Form.Control type="date" className="input-moderno" name="dt_entrada" value={state.item.dt_entrada} onChange={changeItem} disabled={state.acao === "Visualizar"} /></div>
                            <div className="col-md-2"><Form.Label className="label-admin">Data Saída</Form.Label><Form.Control type="date" className="input-moderno" name="dt_saida" value={state.item.dt_saida} onChange={changeItem} disabled={state.acao === "Visualizar"} /></div>
                            <div className="col-md-2"><Form.Label className="label-admin">Ano Fabr.</Form.Label><Form.Control type="number" className="input-moderno" name="ano_fabricacao" value={state.item.ano_fabricacao} onChange={changeItem} disabled={state.acao === "Visualizar"} /></div>
                            <div className="col-md-2"><Form.Label className="label-admin">Década Fabr.</Form.Label><Form.Control type="number" className="input-moderno" name="decada_fabricacao" value={state.item.decada_fabricacao} onChange={changeItem} disabled={state.acao === "Visualizar"} /></div>
                        </div>

                        {/* GRUPO 5: CONSERVAÇÃO */}
                        <div className="form-section-header mb-4">
                            <FontAwesomeIcon icon={faTools} className="me-2 text-teal" />
                            <span>Estado de Conservação</span>
                        </div>
                        <div className="row g-4 mb-5">
                            <Form.Group className="col-md-6"><Form.Label className="label-admin">Marcas/Inscrições</Form.Label><Form.Control as="textarea" rows={2} className="input-moderno" name="marcas" value={state.item.marcas} onChange={changeItem} disabled={state.acao === "Visualizar"} /></Form.Group>
                            <Form.Group className="col-md-6"><Form.Label className="label-admin">Estado de Conservação</Form.Label><Form.Control as="textarea" rows={2} className="input-moderno" name="conservacao" value={state.item.conservacao} onChange={changeItem} disabled={state.acao === "Visualizar"} /></Form.Group>
                            <Form.Group className="col-md-12"><Form.Label className="label-admin">Conservação/Restauração (Histórico)</Form.Label><Form.Control as="textarea" rows={2} className="input-moderno" name="restauracao" value={state.item.restauracao} onChange={changeItem} disabled={state.acao === "Visualizar"} /></Form.Group>
                        </div>

                        {/* GRUPO 6: DESCRIÇÕES E PESQUISA */}
                        <div className="form-section-header mb-4">
                            <FontAwesomeIcon icon={faSearchPlus} className="me-2 text-teal" />
                            <span>Descrições e Pesquisa Técnica</span>
                        </div>
                        <div className="row g-4 mb-5">
                            <Form.Group className="col-12"><Form.Label className="label-admin">* Descrição Resumida (Apresentação)</Form.Label><Form.Control as="textarea" rows={3} className="input-moderno" name="apresentacao" value={state.item.apresentacao} onChange={changeItem} disabled={state.acao === "Visualizar"} /></Form.Group>
                            <Form.Group className="col-md-6"><Form.Label className="label-admin">Pesquisa do Acervo</Form.Label><Form.Control as="textarea" rows={4} className="input-moderno" name="pesquisa" value={state.item.pesquisa} onChange={changeItem} disabled={state.acao === "Visualizar"} /></Form.Group>
                            <Form.Group className="col-md-6"><Form.Label className="label-admin">Solicitação para Exposição</Form.Label><Form.Control as="textarea" rows={4} className="input-moderno" name="solicitacao" value={state.item.solicitacao} onChange={changeItem} disabled={state.acao === "Visualizar"} /></Form.Group>
                            <Form.Group className="col-md-6"><Form.Label className="label-admin">Bibliografia</Form.Label><Form.Control as="textarea" rows={4} className="input-moderno" name="bibliografia" value={state.item.bibliografia} onChange={changeItem} disabled={state.acao === "Visualizar"} /></Form.Group>
                            <Form.Group className="col-md-6"><Form.Label className="label-admin">Histórico</Form.Label><Form.Control as="textarea" rows={4} className="input-moderno" name="historico" value={state.item.historico} onChange={changeItem} disabled={state.acao === "Visualizar"} /></Form.Group>
                            <Form.Group className="col-12"><Form.Label className="label-admin">Observação</Form.Label><Form.Control as="textarea" rows={2} className="input-moderno" name="observacao" value={state.item.observacao} onChange={changeItem} disabled={state.acao === "Visualizar"} /></Form.Group>
                        </div>

                        {/* GRUPO 7: DOCUMENTAÇÃO FOTOGRÁFICA */}
                        <div className="form-section-header mb-4">
                            <FontAwesomeIcon icon={faHistory} className="me-2 text-teal" />
                            <span>Fotos Históricas</span>
                        </div>
                        <div className="row mb-5">
                            <div className="col-12">
                                {state.carregarFotos && (
                                    <FotosHistoricasDropzone fotosHistoricasAdicionadas={fotosHistoricasAdicionadas} fotosHistoricasSalvas={state.fotosHistoricas.salvas} disabled={state.acao === "Visualizar"} />
                                )}
                            </div>
                        </div>

                        {/* GRUPO 8: CONTROLE INTERNO */}
                        <div className="row g-4 p-4 bg-light rounded-4 mb-5 align-items-center border">
                            <div className="col-md-4">
                                <Form.Label className="label-admin">Status</Form.Label>
                                <div className="d-flex gap-3">
                                    <Form.Check type="radio" label="Ativo" name="status_item" value="Ativo" checked={state.item.status_item === "Ativo"} onChange={changeItem} disabled={state.acao === "Visualizar"} />
                                    <Form.Check type="radio" label="Inativo" name="status_item" value="Inativo" checked={state.item.status_item === "Inativo"} onChange={changeItem} disabled={state.acao === "Visualizar"} />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <Form.Label className="label-admin">Exposição para visitantes</Form.Label>
                                <div className="d-flex gap-3">
                                    <Form.Check type="radio" label="Sim" name="exposicao" value="Sim" checked={state.item.exposicao === "Sim"} onChange={changeItem} disabled={state.acao === "Visualizar"} />
                                    <Form.Check type="radio" label="Não" name="exposicao" value="Não" checked={state.item.exposicao === "Não" || !state.item.exposicao} onChange={changeItem} disabled={state.acao === "Visualizar"} />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <Form.Label className="label-admin">Inventariado por</Form.Label>
                                <Form.Control className="input-moderno" name="inventariado_por" value={state.item.inventariado_por} onChange={changeItem} disabled={state.acao === "Visualizar"} />
                            </div>
                        </div>

                        {state.acao !== "Visualizar" && (
                            <div className="d-flex justify-content-end gap-3 mt-5 pt-4 border-top">
                                <Button variant="light" className="rounded-pill px-5 fw-bold" onClick={() => navigate("/admin/itens")}>Cancelar</Button>
                                <Button className="btn-apply-filters px-5" onClick={salvarItem}>Salvar item</Button>
                            </div>
                        )}
                    </Form>
                </Card.Body>
            </Card>

        </div>
    );
}